export const defaultLocale = 'en';

export const locales = [defaultLocale, 'de', 'fr', 'ja', 'pt', 'es'] as const;
export type RouterLocale = (typeof locales)[number];

export const translatedPrefixes = locales.slice(1);

export const urlPrefixes: string[] = ['', ...translatedPrefixes];

export const localeExpires = 12 * 30; // 1 year

export const localeMaxAge = localeExpires * 24 * 60 * 60 * 1000; // 1 year

export const localeCookieName = 'LOCALE';
